'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Badge = require('react-bootstrap/lib/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _reactRouterBootstrap = require('react-router-bootstrap');

var _CaseUrlBuilder = require('../../utils/CaseUrlBuilder');

var _CaseUrlBuilder2 = _interopRequireDefault(_CaseUrlBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseTabNavLink = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseTabNavLink, _Component);

  function CaseTabNavLink() {
    _classCallCheck(this, CaseTabNavLink);

    return _possibleConstructorReturn(this, (CaseTabNavLink.__proto__ || Object.getPrototypeOf(CaseTabNavLink)).apply(this, arguments));
  }

  _createClass(CaseTabNavLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          CaseStore = _props.CaseStore,
          counts = _props.counts,
          fromTab = _props.fromTab,
          label = _props.label,
          pathname = _props.pathname,
          toTab = _props.toTab,
          newPath = new _CaseUrlBuilder2.default(pathname).change('main', toTab).toPathname();


      return _react2.default.createElement(
        _reactRouterBootstrap.LinkContainer,
        { to: { pathname: newPath, query: null, state: 'FROM_' + fromTab.toUpperCase() + '_TAB' } },
        _react2.default.createElement(
          _NavItem2.default,
          { className: 'nav-case-main-' + toTab },
          label,
          !!(0, _get3.default)(CaseStore.tabCounts, counts, false) && _react2.default.createElement(
            _Badge2.default,
            { bsStyle: 'success' },
            CaseStore.tabCounts[counts]
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseTabNavLink;
}(_react.Component), _class2.propTypes = {
  CaseStore: _propTypes2.default.object.isRequired,
  counts: _propTypes2.default.string,
  fromTab: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired,
  pathname: _propTypes2.default.string.isRequired,
  toTab: _propTypes2.default.string.isRequired
}, _temp)) || _class) || _class);
var _default = CaseTabNavLink;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseTabNavLink, 'CaseTabNavLink', '/app/src/components/page-case/CaseTabNavLink.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/CaseTabNavLink.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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